import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="w-full bg-[#2b3545] text-white pt-16 pb-8 px-6 md:px-12 overflow-hidden" data-id="element-92">
      <div className="max-w-7xl mx-auto" data-id="element-93">
        {/* Top Section: Sitemap & Services */}
        <div className="flex flex-col lg:flex-row justify-between items-start gap-12 mb-16" data-id="element-94">
          {/* Left: Sitemap Links */}
          <nav aria-label="Sitemap" className="flex flex-col" data-id="element-95">
            <span className="text-[#5bbcd5] text-xs tracking-[0.3em] uppercase mb-4" data-id="element-96">
              Sitemap
            </span>
            <div className="font-bebas tracking-wide text-[#8494a7] leading-[0.9]" data-id="element-97">
              <div className="text-5xl md:text-7xl lg:text-[5.5rem]" data-id="element-98">
                <Link to="/" className="hover:text-[#5bbcd5] transition-colors" data-id="element-99">
                  HOME
                </Link>
                <span className="mx-1" data-id="element-100">/</span>
                <a href="#" className="hover:text-[#5bbcd5] transition-colors" data-id="element-101">
                  OUR SERVICES
                </a>
                <span className="mx-1" data-id="element-102">/</span>
                <Link to="/about-us" className="hover:text-[#5bbcd5] transition-colors" data-id="element-103">
                  ABOUT US
                </Link>
              </div>
              <div className="text-5xl md:text-7xl lg:text-[5.5rem] mt-1" data-id="element-104">
                <Link to="/contact-us" className="hover:text-[#5bbcd5] transition-colors" data-id="element-105">
                  CONTACT US
                </Link>
                <span className="mx-1" data-id="element-106">/</span>
                <Link to="/faq" className="hover:text-[#5bbcd5] transition-colors" data-id="element-107">
                  FAQ
                </Link>
              </div>
            </div>
          </nav>

          {/* Right: Services List */}
          <div className="flex flex-col items-end text-right mt-4 lg:mt-0" data-id="element-108">
            <span className="text-[#5bbcd5] text-xs tracking-[0.3em] uppercase mb-4" data-id="element-109">
              Services
            </span>
            <ul className="font-bebas text-[#8494a7] text-2xl md:text-3xl lg:text-4xl tracking-wide leading-tight space-y-1" data-id="element-110">
              <li data-id="element-111">
                <Link to="/commercial-cleaning" className="hover:text-[#5bbcd5] transition-colors" data-id="element-112">
                  COMMERCIAL CLEANING
                </Link>
              </li>
              <li data-id="element-113">
                <Link to="/basic-home-cleaning" className="hover:text-[#5bbcd5] transition-colors" data-id="element-114">
                  BASIC HOME CLEANING
                </Link>
              </li>
              <li data-id="element-115">
                <Link to="/spring-deep-cleaning" className="hover:text-[#5bbcd5] transition-colors" data-id="element-116">
                  SPRING / DEEP CLEANING
                </Link>
              </li>
              <li data-id="element-117">
                <a href="#" className="hover:text-[#5bbcd5] transition-colors" data-id="element-118">
                  MOVE-IN / MOVE-OUT
                </a>
              </li>
              <li data-id="element-119">
                <a href="#" className="hover:text-[#5bbcd5] transition-colors" data-id="element-120">
                  POST RENOVATION
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Middle Section: Logo & Copyright */}
        <div className="flex flex-col md:flex-row justify-between items-end gap-8 mb-8" data-id="element-121">
          {/* Left: Logo */}
          <div className="flex flex-col items-start" data-id="element-122">
            <img src="https://cdn.magicpatterns.com/uploads/1h9RWLFQ7TTAoyFwfGSDao/sj-website-logo-white.svg" alt="Smith & Jengs Cleaning Services" className="w-24 h-24 object-contain mb-4" data-id="element-123" />
            <img src="https://cdn.magicpatterns.com/uploads/9gJT63RaUddpyfpZWktWUn/sj-website-sj-text-stacked-white.svg" alt="Smith & Jengs" className="w-48 md:w-56 h-auto" width={224} height={80} loading="lazy" data-id="element-124" />
          </div>

          {/* Right: Copyright & Legal */}
          <div className="flex flex-col items-end text-right text-sm text-gray-400" data-id="element-125">
            <span data-id="element-126">© 2026 Smith & Jengs</span>
            <div className="flex gap-2 mt-1" data-id="element-127">
              <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-128">
                Privacy Policy
              </Link>
              <span data-id="element-129">/</span>
              <a href="#" className="hover:text-white transition-colors" data-id="element-130">
                Terms and Conditions
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar: Contact Info */}
        <div className="border-t border-white/10 pt-6" data-id="element-131">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-0 text-sm text-white/80" data-id="element-132">
            <span data-id="element-133">
              <span className="font-semibold" data-id="element-134">email:</span>{' '}
              <a href="mailto:smithsandjengs@yahoo.com" className="hover:text-[#5bbcd5] transition-colors" data-id="element-135">
                smithsandjengs@yahoo.com
              </a>
            </span>
            <span className="hidden md:inline mx-6 text-white/30" data-id="element-136">/</span>
            <span data-id="element-137">
              <span className="font-semibold" data-id="element-138">phone:</span>{' '}
              <a href="tel:07432285564" className="hover:text-[#5bbcd5] transition-colors" data-id="element-139">
                07432285564
              </a>
              <span className="mx-2" data-id="element-140">|</span>
              <a href="tel:01869601439" className="hover:text-[#5bbcd5] transition-colors" data-id="element-141">
                01869601439
              </a>
            </span>
            <span className="hidden md:inline mx-6 text-white/30" data-id="element-142">/</span>
            <span data-id="element-143">
              <span className="font-semibold" data-id="element-144">facebook:</span>{' '}
              <a href="https://www.facebook.com/SmithandJengs/" target="_blank" rel="noopener noreferrer" className="hover:text-[#5bbcd5] transition-colors" data-id="element-145">
                smithsandjengs
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>;
}